// extracted by mini-css-extract-plugin
export default {"suggestionTitle":"use-reference-suggestions-module__suggestionTitle--N45Y8"};